export function setTimeZone(timeZone = 'Europe/Kiev', elementId = 'time', timeZoneName = '') {
    const timeContainer = document.getElementById(elementId);

    if (timeContainer) {
        const options = {
            timeZone: timeZone,
            hour12: false,
            hour: 'numeric',
            minute: '2-digit'
        };

        let ticker = true;
        let timeZoneNameValue = (timeZoneName == '' ? getTimeZoneName(timeZone) : timeZoneName);

        const tick = () => {
            const now = new Date();
            const time = now.toLocaleString('en', options).replace(':', ticker ? '<span style="visibility: hidden">:</span>' : '<span>:</span>');

            ticker = !ticker;

            timeContainer.innerHTML = timeZoneNameValue + ' ( ' + time + ' )';
        }

        setInterval(tick, 1000);

        tick();
    }
}

export function realTimeUpdateCountryTimeZones(response) {
    let countries = response.data;
    let listIds = countries.map((country) => country.id);

    const tickRandom = () => {
        let list = getRandomList(listIds);

        list.forEach((id, index) => {
            countries.forEach((item) => {
                if (id == item.id) {
                    let position = index == 0 ? 'first' : 'second';

                    setTimeZone(item.timezone, 'banner-country-timezone-' + position);
                }
            });
        });
    }

    tickRandom();

    setInterval(tickRandom, 10000);
}

function getTimeZoneName(timeZone) {
    if ('Europe/Kiev' === timeZone) {
        return 'EEST';
    } else if ('America/New_York' === timeZone) {
        return 'EDT';
    } else if ('America/Toronto' === timeZone) {
        return 'EDT';
    } else if ('Europe/London' === timeZone) {
        return 'BST';
    }

    return new Intl.DateTimeFormat('en', { timeZone: timeZone, timeZoneName: 'short' })
        .formatToParts(new Date())
        .find((part) => part.type === 'timeZoneName').value
    ;
}

function getRandomList(list) {
    const numbersArray = list;
    const randomIndexes = [];

    let randomIndex = Math.floor(Math.random() * numbersArray.length);
    randomIndexes.push(randomIndex);

    while (randomIndexes.length < 2) {
      randomIndex = Math.floor(Math.random() * numbersArray.length);

      if (!randomIndexes.includes(randomIndex)) {
        randomIndexes.push(randomIndex);
      }
    }

    const randomNumbers = randomIndexes.map(index => numbersArray[index]);

    return randomNumbers;

}